var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFalkon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3430 3430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ddd"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce4300"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "149%",
    x2: "-21%",
    y1: "-27%",
    y2: "99%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d446ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a0d8ff"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "99%",
    x2: "35%",
    y1: "13%",
    y2: "41%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "42%",
    x2: "96%",
    y1: "21%",
    y2: "-8%",
    xlinkHref: "#a"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "52%",
    x2: "3%",
    y1: "71%",
    y2: "9%",
    xlinkHref: "#a"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "34%",
    x2: "-40%",
    y1: "32%",
    y2: "123%",
    xlinkHref: "#b"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "96%",
    x2: "-11%",
    y1: "2%",
    y2: "35%",
    xlinkHref: "#b"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "55%",
    x2: "-64%",
    y1: "40%",
    y2: "222%",
    xlinkHref: "#b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    stroke: "#a3a3a3",
    strokeWidth: 50,
    d: "M126 1718c0-862 712-1561 1590-1561s1590 699 1590 1561-712 1561-1590 1561S126 2580 126 1718z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M680 3245s497-1740 2430-1518c0 0-1230-730-2423 254-352 817-8 1264-8 1264z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M830 3025s518-1250 1903-1272c-1053 256 1 1165 1 1165s-834 754-1904 107z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M540 2066s1036-1140 2583-350c-28-214-210-455-540-524-72-35-604-857-1747-384 352 28 503 77 510 114-606-105-786 760-806 1145z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M2025 1100s266-95 300 187c-260 25-300-187-300-187z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M675 3250s452-1477 1967-1534c0 0-1230-225-2097 1150-5 195 130 384 130 384z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M838 807s378 23 512 113c56-10 104-50 112-102-48-20-490-56-625-12z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M544 2068s473-568 1427-635c0 0-1300 58-1408 425-30 90-20 210-20 210z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkon);
export default __webpack_public_path__ + "static/media/falkon.bc602a87747f879dcb83cbb58cc03d7e.svg";
export { ForwardRef as ReactComponent };